const { formatText } = require('core/i18n').i18n;

const texts = () => {
    return [
        [
            formatText('insuranceRequestHome-step2GuideTextNone')
        ],
        [
            formatText('insuranceRequestHome-step2GuideTextHobbies'),
            formatText('insuranceRequestHome-step2GuideTextCollectionObjects')
        ],
        [
            formatText('insuranceRequestHome-step2GuideTextHobbies'),
            formatText('insuranceRequestHome-step2GuideTextHighValueCollectionObjects'),
            formatText('insuranceRequestHome-step2GuideTextTechObjects'),
            formatText('insuranceRequestHome-step2GuideTextExpensiveFurniture'),
            formatText('insuranceRequestHome-step2GuideTextFurCoats')
        ]
    ]
};

module.exports = {
    texts
};
